export default "__VITE_ASSET__Bh694K2L__"